import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
/**
 * @deprecated use complex dialog v3 component instead
 */
export class ComplexDialogEmbeddedViewService {
  _dialogData$ = new Subject();
  _componentTypeData$ = new Subject();
  _dataOutputForComponent$ = new Subject();
  emitDialogData(data, key) {
    this._dialogData$.next({
      data,
      key
    });
  }
  emitComponentType(componentType, key) {
    this._componentTypeData$.next({
      componentType,
      key
    });
  }
  emitDataOutputForComponent(data) {
    this._dataOutputForComponent$.next(data);
  }
  get dialogData$() {
    return this._dialogData$.asObservable();
  }
  get dataOutputForComponent$() {
    return this._dataOutputForComponent$.asObservable();
  }
  get componentTyeData() {
    return this._componentTypeData$.asObservable();
  }
  static ɵfac = function ComplexDialogEmbeddedViewService_Factory(t) {
    return new (t || ComplexDialogEmbeddedViewService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ComplexDialogEmbeddedViewService,
    factory: ComplexDialogEmbeddedViewService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplexDialogEmbeddedViewService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
